var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlignSb = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 39.995V215.995",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 56H45C42.7909 56 41 59.5817 41 64V100C41 104.418 42.7909 108 45 108H89C91.2091 108 93 104.418 93 100V64C93 59.5817 91.2091 56 89 56Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 146H45C42.7909 146 41 149.582 41 154V190C41 194.418 42.7909 198 45 198H89C91.2091 198 93 194.418 93 190V154C93 149.582 91.2091 146 89 146Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.111 56H164.889C163.293 56 162 59.5817 162 64V100C162 104.418 163.293 108 164.889 108H211.111C212.707 108 214 104.418 214 100V64C214 59.5817 212.707 56 211.111 56Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.111 146H164.889C163.293 146 162 149.582 162 154V190C162 194.418 163.293 198 164.889 198H211.111C212.707 198 214 194.418 214 190V154C214 149.582 212.707 146 211.111 146Z",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 39.995V215.995",
    stroke: "black",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlignSb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/align-sb.a5385022956af1accd2d3c1431dfe67a.svg";